module.exports = {"450403001":"城东街道","450403002":"城南街道","450403003":"城中办街道事处","450403004":"城北办街道事处","450403005":"角嘴街道","450403006":"东兴街道","450403007":"富民街道","450403101":"城东镇","450403103":"龙湖镇","450403104":"夏郢镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450403.json
// module id = 2110
// module chunks = 0